module.exports = __webpack_public_path__ + "assets_1773901505253/img/guide_ios.431fc979.png";